import React from "react";
import BookingContainer from "containers/BookingTable";

const BookingTable = (props) => {
  return (
    <BookingContainer {...props}/>
  );
};

export default BookingTable;
